import React, { useEffect, useState, version } from "react";
import Select from "react-select";
import { AuditAdminData } from "../../data/AuditAdminData";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { login } from "../../auth/msalAuth";

import {
  Alert,
  Box,
  CircularProgress,
  IconButton,
  Modal,
  Snackbar,
} from "@mui/material";
import "./formComponent.scss";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import { useRecoilState, useSetRecoilState } from "recoil";
import { protocolType } from "../../../store/audit details/atom";
import { formProgress } from "../../../store/atoms";
import LeadAuditExcel from "../../reusables/LeadAuditExcel";

const FormComponent = () => {
  const [formData, setFormData] = useState({
    version: 1,
    audit_criteria: "[]",
    audit_start_date: "",
    audit_end_date: "",
  });
  const [rows, setRows] = useState([]); // State for additional rows
  // const [rows, setRows] = useState()
  const [focusAreaField, setFocusAreaField] = useState([]);
  const setProtocolType = useSetRecoilState(protocolType);
  const [progressvalue, setFormProgress] = useRecoilState(formProgress);
  const [loading, setLoading] = useState({
    save: false,
    submit: false,
  });
  const [dataLoading, setDataLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [submitDisable, setSubmitDisable] = useState(true);
  const [cityData, setCityData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [formattedStartDate, setFormattedStartDate] = useState("");
  const [formattedEndDate, setFormattedEndDate] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [unitDetails, setUnitDetails] = useState([]);
  const [unitIndex, setUnitIndex] = useState("");
  const [error, setError] = useState(false);
  const [criteriaOptions, setCriteriaOptions] = useState([]); // New state for criteria options

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");

  // if (formData.audit_team && Boolean(Object.keys(formData?.audit_team)[0])) {

  // }

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Parse the audit_criteria string to an array
  const selectedValues = formData.audit_criteria
    ? JSON.parse(formData.audit_criteria)
    : [];

  // Find the corresponding options based on the selected values
  const selectedOptions = selectedValues.map((value) => {
    const option = (
      criteriaOptions.length > 0
        ? criteriaOptions
        : AuditAdminData.auditCriteria.options
    ).find((opt) => opt.value === value);
    return option || { value, label: value };
  });

  const handleMultiSelectChange = (selectedOption) => {
    if (!selectedOption) {
      // Handle case when all options are cleared
      setFormData((prevData) => ({
        ...prevData,
        audit_criteria: "[]",
      }));
      return;
    }

    const values = selectedOption.map((option) => option.value);
    setFormData((prevData) => ({
      ...prevData,
      audit_criteria: JSON.stringify(values),
    }));
  };

  const addRow = () => {
    if (rows.length < 4) {
      setRows([...rows, { name: "", function: "" }]);
    }
  };
  const addFocusAreaRows = () => {
    if (focusAreaField.length < 5) {
      setFocusAreaField([...focusAreaField, ""]);
    }
  };

  const removeFocusAreaRow = (index) => {
    const updatedFields = focusAreaField.filter((_, i) => i !== index);
    setFocusAreaField(updatedFields);
  };

  const removeRow = (index) => {
    const updatedFields = rows.filter((_, i) => i !== index);

    setRows(updatedFields);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  const handleFocusAreaChange = (index, value) => {
    const updatedFocusArea = [...focusAreaField];
    updatedFocusArea[index] = value;
    setFocusAreaField(updatedFocusArea);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  // function formatDate(dateStr) {
  //  const date = new Date(dateStr + "T00:00:00Z"); // force UTC

  //   const months = [
  //     "Jan",
  //     "Feb",
  //     "Mar",
  //     "Apr",
  //     "May",
  //     "Jun",
  //     "Jul",
  //     "Aug",
  //     "Sep",
  //     "Oct",
  //     "Nov",
  //     "Dec",
  //   ];

  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = months[date.getMonth()];
  //   const year = date.getFullYear();

  //   // Return the formatted date
  //   return `${day}-${month}-${year}`;
  // }

  function formatDate(dateStr) {
    const date = new Date(dateStr + "T00:00:00Z"); // force UTC

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

  const checkformDataValues = formData
    ? Boolean(formData.audit_criteria) &&
      Boolean(formData.audit_delivery) &&
      Boolean(formData.audit_end_date) &&
      Boolean(formData.audit_start_date) &&
      Boolean(formData.audit_language) &&
      Boolean(formData.audit_type) &&
      Boolean(formData.lead_auditor) &&
      Boolean(formData.lead_auditor_function) &&
      Boolean(formData.cb_office_location) &&
      Boolean(formData.version) &&
      Boolean(formData.jobnumber)
    : false;

  const checkAdditionalAttendies = () => {
    for (let i = 0; i < rows.length; i++) {
      const obj = rows[i];
      if (obj.name && obj.function) {
        return true;
      }
    }
    return false;
  };
  const checkAttendies = checkAdditionalAttendies();
  const checkFocusAreaField = Boolean(focusAreaField[0]);

  const submitForm = async (activity) => {
    try {
      if (activity === "saved") {
        setSnackbarMessage("Form Saved Successfully!");
        setLoading((prev) => ({
          ...prev,
          save: true,
        }));
      }
      if (activity === "completed") {
        setSnackbarMessage("Form Submitted Successfully!");
        setLoading((prev) => ({
          ...prev,
          submit: true,
        }));
      }
      // setloading(true);
      const auditTeamObject = rows.reduce((acc, row) => {
        acc[row.name] = row.function; // Adjust this to store other information if necessary
        return acc;
      }, {});

      const cleanedObj = Object.fromEntries(
        Object.entries(auditTeamObject).filter(
          ([key, value]) => key !== "" && value !== ""
        )
      );

      // const refineAudintTeamObject = delete auditTeamObject[""]
      const foucsAreaVerify = focusAreaField.filter((item) => item !== "");

      const payload = {
        form_id: auditNumber,
        formData,
        additional_attendee: cleanedObj,
        audit_focus_area: foucsAreaVerify,
        activity: activity,
      };
      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/submit_audit`;
      const token = await getToken();

      const response = await axios.post(url, payload, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;

        const type = json[1]?.protocol;
        if (activity === "saved") {
          setOpen(true);
          setLoading((prev) => ({
            ...prev,
            save: false,
          }));
        }
        if (activity === "completed") {
          // setOpen(true);
          setLoading((prev) => ({
            ...prev,
            submit: false,
          }));
          // setOpen(true);
          setTimeout(() => {
            setFormProgress(2);
            setProtocolType(type);
          }, 2000);
        }
        // setProtocolType()
      }
    } catch (e) {
      if (activity === "saved") {
        setLoading((prev) => ({
          ...prev,
          save: false,
        }));
      }
      if (activity === "completed") {
        setLoading((prev) => ({
          ...prev,
          submit: false,
        }));
      }
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const getFormData = async () => {
    try {
      setDataLoading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        setFormData(json);
        if (json.audit_team) {
          const updatedData = Object.entries(json.audit_team).map(
            ([name, func]) => ({
              name,
              function: func,
            })
          );
          setRows(updatedData);
        }
        if (json?.audit_focus_area) {
          setFocusAreaField(json.audit_focus_area);
        }
        setDataLoading(false);
      }
    } catch (e) {
      setDataLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };
  const getOfficeLocationAndLanguage = async () => {
    try {
      setDataLoading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/audit/get_city_language`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;

        const languages = json && json?.language;
        const cities = json && json?.location;

        setCityData(cities || []);
        setLanguageData(languages || []);
        setDataLoading(false);
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setDataLoading(false);
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const getActiveTechnicalStandards = async () => {
    try {
      const url = `${process.env.REACT_APP_SERVER_URL}/api/audit/get_all_active_tech_std`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        console.log("Active technical standards:", json);

        // Transform the API response to match the expected format
        if (json.standards && Array.isArray(json.standards)) {
          const transformedOptions = json.standards.map((standard) => ({
            value: standard,
            label: standard,
          }));
          setCriteriaOptions(transformedOptions);
        } else {
          setCriteriaOptions([]);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the get_all_active_tech_std API:", e);
      setCriteriaOptions([]); // Set empty array on error
    }
  };

  const unitDetailsInfo = async () => {
    const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${auditNumber}`;
    const token = await getToken();
    try {
      setLoading(true);
      const response = await axios.get(viewUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        const unit_index = data?.unitIndex;
        const combinedData = [
          ...data.unitDetails.unitDetails,
          ...data.unitDetails.offSiteFields,
        ];
        if (combinedData) {
          setUnitDetails(combinedData);
        }
        if (unit_index) {
          setUnitIndex(unit_index);
        }

        console.log("combine data", combinedData);
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }

      console.log("getting error while calling the api");
    }
  };

  const formattedCityData =
    cityData.length > 0 &&
    cityData.map((item) => ({
      label: item,
      value: item,
    }));

  const formattedLanguageData =
    languageData.length > 0 &&
    languageData.map((item) => ({
      label: item,
      value: item,
    }));

  useEffect(() => {
    if (
      checkformDataValues &&
      // checkAttendies &&
      formData?.audit_criteria !== "[]" &&
      formData.is_fssc_conjunction !== undefined
    ) {
      setSubmitDisable(false);
    } else {
      setSubmitDisable(true);
    }
  }, [checkFocusAreaField, checkAttendies, checkformDataValues, formData]);

  useEffect(() => {
    if (formData?.audit_end_date < formData?.audit_start_date) {
      // alert("working")
      setFormData((prev) => ({
        ...prev,
        audit_end_date: "",
      }));
    }
  }, [formData.audit_start_date]);

  useEffect(() => {
    unitDetailsInfo();
    getFormData();
    getOfficeLocationAndLanguage();
    getActiveTechnicalStandards(); // Add call to fetch active technical standards
    // getAutoPopulateData();
  }, []);

  // Effect to adjust multiselect height when selections change
  useEffect(() => {
    const adjustMultiselectHeight = () => {
      const multiselectControl = document.querySelector(
        ".multiselect-expandable .searchable-select__control"
      );
      const multiselectValueContainer = document.querySelector(
        ".multiselect-expandable .searchable-select__value-container"
      );

      if (multiselectControl && multiselectValueContainer) {
        // Force height recalculation
        multiselectControl.style.height = "auto";
        multiselectValueContainer.style.height = "auto";

        // Get the actual content height
        const contentHeight = multiselectValueContainer.scrollHeight;
        const minHeight = 44;
        const newHeight = Math.max(contentHeight + 16, minHeight); // Add padding

        // Apply the new height
        multiselectControl.style.height = `${newHeight}px`;
        multiselectValueContainer.style.height = `${newHeight}px`;
      }
    };

    // Adjust height after a short delay to ensure DOM is updated
    const timeoutId = setTimeout(adjustMultiselectHeight, 100);

    return () => clearTimeout(timeoutId);
  }, [selectedOptions]); // Re-run when selections change

  const transformData = (excelData) => {
    if (typeof excelData !== "object" || excelData === null) {
      console.error("Expected an object but received:", excelData);
      return {};
    }

    const {
      form_id,
      segment,
      uiut,
      phase,
      protocol_type,
      phase_status,
      activity,
    } = excelData;
    return {
      "Audit Number": form_id || "N/A",
      Segment: segment || "N/A",
      "Unit Index + Unit Name": uiut || "N/A",
      "Phase Stage": phase || "N/A",
      "Protocol Type": protocol_type || "N/A",
      "Phase Progress": phase_status || "N/A",
      "Overall Audit Progress": activity || "N/A",
    };
  };

  console.log("newww", formattedStartDate, formattedEndDate);

  useEffect(() => {
    if (formData?.audit_start_date) {
      const formattedDate = formatDate(formData?.audit_start_date);
      setFormattedStartDate(formattedDate);
    } else {
      setFormattedStartDate("");
    }
    if (formData?.audit_end_date) {
      const formattedDate = formatDate(formData?.audit_end_date);
      setFormattedEndDate(formattedDate);
    } else {
      setFormattedEndDate("");
    }
  }, [formData.audit_start_date, formData.audit_end_date, formData]);

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split("T")[0];
    setCurrentDate(today);
  }, []);

  // console.log("current date", currentDate)

  return (
    <>
      {dataLoading ? (
        <Modal open={dataLoading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full viewport height
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              backdropFilter: "blur(5px)", // Adding a blur effect for the background
              borderRadius: "10px", // Rounded corners
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      ) : (
        <>
          {" "}
          <div id="audit-details-form-component">
            <span style={{ display: "grid", justifyContent: "flex-end" }}>
              <LeadAuditExcel
                excelData={formData}
                fileName={`${unitIndex}_${auditNumber}_${new Date().getTime()}`}
                transformData={transformData}
                sheetName={["Unit Details", "Audit details"]}
                color="ff8200"
                focusArea={focusAreaField}
                additionalAttendees={rows}
                unitDetails={unitDetails}
              />
            </span>
            <form onSubmit={handleSubmit}>
              <div className="form-component-container">
                {/* CB Office Location */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.cbOfficeLocation.label}{" "}
                    <span className="required-red-text">*</span>
                  </label>
                  <Select
                    options={
                      formattedCityData.length > 0 ? formattedCityData : []
                    }
                    value={
                      (formattedCityData.length > 0 &&
                        formattedCityData.find(
                          (option) =>
                            option.value === formData.cb_office_location
                        )) ||
                      null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.cbOfficeLocation.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className="searchable-select"
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.cbOfficeLocation.name}
                    // defaultOptions={formattedCityData.length > 0 ? formattedCityData.slice(0, 10) : []}
                  />
                </div>
                {/* Audit Language */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditLanguage.label}
                    <span className="required-red-text">*</span>
                  </label>
                  <Select
                    options={
                      formattedLanguageData.length > 0
                        ? formattedLanguageData
                        : []
                    }
                    value={
                      (formattedLanguageData.length > 0 &&
                        formattedLanguageData.find(
                          (option) => option.value === formData.audit_language
                        )) ||
                      null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditLanguage.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className="searchable-select"
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditLanguage.name}
                  />
                </div>

                {/* FSSC Certification Audit */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.fsscCertificationAudit.label}
                    <span className="required-red-text">*</span>
                  </label>
                  <div className="radio-container">
                    {AuditAdminData.fsscCertificationAudit.options.map(
                      (option, idx) => (
                        <label
                          className="radio-field"
                          key={idx}
                          style={{ marginRight: "10px" }}
                        >
                          <input
                            className="radio-circle"
                            type="radio"
                            name={AuditAdminData.fsscCertificationAudit.name}
                            value={option.value}
                            required={
                              AuditAdminData.fsscCertificationAudit.required
                            }
                            checked={
                              formData.is_fssc_conjunction === option.value
                            }
                            onChange={() =>
                              handleInputChange(
                                AuditAdminData.fsscCertificationAudit.name,
                                option.value
                              )
                            }
                          />
                          <span className="radio-option-text">
                            {option.label}
                          </span>
                        </label>
                      )
                    )}
                  </div>
                </div>

                {/* Audit Criteria */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditCriteria.label}
                    <span className="required-red-text">*</span>
                    <span
                      style={{
                        fontWeight: "normal",
                      }}
                    >
                      -
                    </span>
                    <i
                      style={{
                        color: "gray",
                      }}
                    >
                      You can select more than one option{" "}
                    </i>
                  </label>
                  <Select
                    isMulti
                    options={
                      criteriaOptions.length > 0
                        ? criteriaOptions
                        : AuditAdminData.auditCriteria.options
                    }
                    value={selectedOptions}
                    onChange={handleMultiSelectChange}
                    isSearchable={true}
                    className="searchable-select multiselect-expandable"
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditCriteria.name}
                    onKeyDown={(e) => e.preventDefault()} // Prevent typing
                    onInput={(e) => e.preventDefault()}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isClearable={true}
                    placeholder="Select standards..."
                    noOptionsMessage={() => "No standards available"}
                    loadingMessage={() => "Loading standards..."}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "100%",
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "44px",
                        height: "auto",
                        maxHeight: "none",
                        overflow: "visible",
                        "&:hover": {
                          borderColor: "#0000a0",
                        },
                      }),
                      valueContainer: (provided, state) => ({
                        ...provided,
                        height: "auto",
                        minHeight: "44px",
                        maxHeight: "none",
                        overflow: "visible",
                        padding: "8px 12px",
                        flexWrap: "wrap",
                        alignItems: "flex-start",
                      }),
                      input: (provided) => ({
                        ...provided,
                        margin: "0px",
                        padding: "0px",
                        height: "auto",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#0000a0",
                        color: "white",
                        borderRadius: "4px",
                        margin: "2px",
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "white",
                        fontWeight: "500",
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "white",
                        ":hover": {
                          backgroundColor: "#000080",
                          color: "white",
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>

                {/* Audit Start Date */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditStartDate.label}
                    <span className="required-red-text">*</span>{" "}
                    {formattedStartDate && (
                      <span>( {formattedStartDate} )</span>
                    )}
                  </label>
                  <input
                    className="input-field"
                    type={AuditAdminData.auditStartDate.type}
                    name={AuditAdminData.auditStartDate.name}
                    placeholder={AuditAdminData.auditStartDate.placeholder}
                    required={AuditAdminData.auditStartDate.required}
                    value={formData.audit_start_date || ""}
                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.auditStartDate.name,
                        e.target.value
                      )
                    }
                    // min={currentDate}
                    onKeyDown={(e) => e.preventDefault()} // Prevent typing
                    onInput={(e) => e.preventDefault()}
                  />
                </div>

                {/* Audit End Date */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditEndDate.label}
                    <span className="required-red-text">*</span>{" "}
                    {formattedEndDate && <span>( {formattedEndDate} )</span>}
                  </label>
                  <input
                    className="input-field"
                    type={AuditAdminData.auditEndDate.type}
                    placeholder={AuditAdminData.auditEndDate.placeholder}
                    required={AuditAdminData.auditEndDate.required}
                    value={formData.audit_end_date || ""}
                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.auditEndDate.name,
                        e.target.value
                      )
                    }
                    name={AuditAdminData.auditEndDate.name}
                    min={formData.audit_start_date}
                    onKeyDown={(e) => e.preventDefault()} // Prevent typing
                    onInput={(e) => e.preventDefault()}
                  />
                </div>

                {/* Audit Delivery */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditDelivery.label}
                    <span className="required-red-text">*</span>
                  </label>
                  <Select
                    options={AuditAdminData.auditDelivery.options}
                    value={
                      AuditAdminData.auditDelivery.options.find(
                        (option) => option.value === formData.audit_delivery
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditDelivery.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className="searchable-select"
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditDelivery.name}
                  />
                </div>

                {/* Audit Type */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditType.label}
                    <span className="required-red-text">*</span>
                  </label>
                  <Select
                    options={AuditAdminData.auditType.options}
                    value={
                      AuditAdminData.auditType.options.find(
                        (option) => option.value === formData.audit_type
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditType.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className="searchable-select"
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditType.name}
                  />
                </div>
                <div>
                  {/* Version */}
                  <div className="input-box">
                    <label className="input-label">
                      {AuditAdminData.version.label}
                    </label>
                    <input
                      className="input-field"
                      type={AuditAdminData.version.type}
                      name={AuditAdminData.version.name}
                      placeholder={AuditAdminData.version.placeholder}
                      required={AuditAdminData.version.required}
                      value={formData.version || ""}
                      disabled
                      // onChange={(e) =>
                      //   handleInputChange(
                      //     AuditAdminData.version.name,
                      //     e.target.value
                      //   )
                      // }
                    />
                  </div>

                  {/* Job Number */}
                  <div className="input-box pt-[10px]">
                    <label className="input-label">
                      {AuditAdminData.jobnumber.label}
                      <span className="required-red-text">*</span>
                    </label>
                    <input
                      className="input-field"
                      type={AuditAdminData.jobnumber.type}
                      name={AuditAdminData.jobnumber.name}
                      placeholder={AuditAdminData.jobnumber.placeholder}
                      required={AuditAdminData.jobnumber.required}
                      value={formData.jobnumber || ""}
                      // onChange={(e) =>
                      //   handleInputChange(
                      //     AuditAdminData.jobnumber.name,
                      //     e.target.value
                      //   )
                      // }
                      onChange={(e) => {
                        const value = e.target.value;

                        // allow only alphanumeric characters
                        if (/^[a-zA-Z0-9]*$/.test(value)) {
                          handleInputChange(
                            AuditAdminData.jobnumber.name,
                            value
                          );
                        }
                      }}
                    />
                  </div>
                </div>

                {/* //Audit Team  */}
                <div>
                  <div className="audit-name-field">
                    <label className="input-label">
                      Audit Team <span className="required-red-text">*</span>{" "}
                    </label>
                    <div
                      style={{
                        display: "grid",
                        alignItems: "center",
                        alignContent: "center",
                        gridTemplateColumns: "1fr 50px",
                        gap: "10px",
                      }}
                    >
                      <div className="bottom-inputs">
                        <input
                          className="input-fields"
                          type="text"
                          placeholder="Lead Auditor Name"
                          value={formData.lead_auditor || ""}
                          name="lead_auditor"
                          onChange={(e) =>
                            handleInputChange("lead_auditor", e.target.value)
                          }
                        />
                        <select
                          className="input-fields"
                          id="mySelect"
                          value={formData.lead_auditor_function || ""}
                          onChange={(e) =>
                            handleInputChange(
                              "lead_auditor_function",
                              e.target.value
                            )
                          }
                        >
                          <option value="">Select Lead Auditor</option>
                          <option value="Lead Auditor">Lead Auditor</option>

                          {/* <option value="Llyod's Register Quality Assurance (LRQA)">
                            Llyod's Register Quality Assurance (LRQA)
                          </option>
                          <option value="Bureau Veritas (BV)">
                            Bureau Veritas (BV)
                          </option>
                          <option value="British Standards Institution (BSI)">
                            British Standards Institution (BSI)
                          </option>{" "}
                          <option value="None">None</option> */}
                        </select>
                      </div>
                    </div>
                    {rows.map((_, index) => (
                      <div
                        style={{
                          display: "grid",
                          alignItems: "center",
                          alignContent: "center",
                          gridTemplateColumns:
                            index !== 0 ? "1fr 50px" : "1fr 50px",
                          gap: "10px",
                        }}
                      >
                        <div className="bottom-inputs">
                          <input
                            className="input-fields"
                            type="text"
                            placeholder="Additional Attendees Name"
                            value={rows[index].name}
                            onChange={(e) =>
                              handleRowChange(index, "name", e.target.value)
                            }
                          />
                          <select
                            className="input-fields"
                            id="mySelect"
                            value={rows[index].function}
                            onChange={(e) =>
                              handleRowChange(index, "function", e.target.value)
                            }
                          >
                            <option value="">
                              Select Additional Attendees
                            </option>
                            <option value="Team Member">Team Member</option>
                            <option value="Observer">Observer</option>
                            <option value="Witness">Witness</option>{" "}
                            <option value="None">None</option>
                          </select>
                        </div>
                        {/* {index !== 0 && (  */}
                        <IconButton
                          onClick={() => removeRow(index)}
                          className="closeBtn"
                          sx={{
                            background: "#0000a0",
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                            marginTop: "10px",
                          }}
                        >
                          <CloseIcon sx={{ color: "white" }} />
                        </IconButton>
                        {/* )} */}
                      </div>
                    ))}
                  </div>
                  <div className="add-icon">
                    <IconButton
                      onClick={addRow}
                      disabled={rows.length === 4}
                      style={{
                        cursor: rows.length === 4 ? "not-allowed" : "",
                      }}
                    >
                      <AddCircleIcon
                        sx={{
                          color: rows.length === 4 ? "#d4d4d4" : "",
                        }}
                      />
                    </IconButton>
                    Add more attendees
                  </div>
                </div>

                {/* Audit Focus Area */}

                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditFocusArea.label}
                  </label>
                  {/* <input
                className="input-field"
                type={AuditAdminData.auditFocusArea.type}
                name="auditFocusArea"
                placeholder={AuditAdminData.auditFocusArea.placeholder}
                required={AuditAdminData.auditFocusArea.required}
                value={formData.auditFocusArea || ""}
                onChange={(e) =>
                  handleInputChange("auditFocusArea", e.target.value)
                }
              /> */}
                  {focusAreaField?.map((item, index) => (
                    <div
                      style={{
                        display: "grid",
                        alignItems: "center",
                        alignContent: "center",
                        gridTemplateColumns: "1fr 50px",
                        gap: "10px",
                      }}
                      key={index}
                    >
                      <input
                        className="input-field"
                        type={AuditAdminData.auditFocusArea.type}
                        name="auditFocusArea"
                        placeholder={AuditAdminData.auditFocusArea.placeholder}
                        required={AuditAdminData.auditFocusArea.required}
                        value={focusAreaField[index] || ""}
                        onChange={(e) =>
                          handleFocusAreaChange(index, e.target.value)
                        }
                      />
                      {index !== 0 && ( // Hide close icon for the first input
                        <IconButton
                          className="closeBtn"
                          sx={{
                            background: "#0000a0",
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                            marginTop: "10px",
                          }}
                          onClick={() => removeFocusAreaRow(index)}
                        >
                          <CloseIcon sx={{ color: "white" }} />
                        </IconButton>
                      )}
                    </div>
                  ))}
                  <div className="add-icon">
                    <IconButton
                      onClick={addFocusAreaRows}
                      disabled={focusAreaField.length === 5}
                      style={{
                        cursor:
                          focusAreaField.length === 5 ? "not-allowed" : "",
                      }}
                    >
                      <AddCircleIcon
                        sx={{
                          color: focusAreaField.length === 5 ? "#d4d4d4" : "",
                        }}
                      />
                    </IconButton>
                    Add another row
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="bottom-container">
            <div className="required-text">
              Fields marked <span>*</span> are Required.
            </div>
            <div id="action-button-container">
              {loading.save ? (
                <button className="action-btn" disabled>
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => {
                    submitForm("saved");
                  }}
                  className="action-btn"
                >
                  Save
                </button>
              )}
              {loading.submit ? (
                <button className="action-btn" disabled>
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => {
                    setOpenPopup(true);
                  }}
                  className="action-btn"
                  disabled={submitDisable}
                >
                  Next
                </button>
              )}
            </div>

            <Dialog
              open={openPopup}
              onClose={() => {
                setOpenPopup(false);
              }}
              id="mars-super-admin-popup"
            >
              <DialogContent>
                <div className="popup-text-container">
                  <span>
                  <p style={{width:"90%",margin:"auto",display:"block"}} className="mb-3">
                    Please confirm your submission. Once you click "Next", your
                    data cannot be modified or edited.
                  </p>
                  <span className="text-left text-[12px] grid">You have selected the
                    following Audit Criteria (Applicable Standards or Technical
                    Specifications)</span>
                  </span>
                 
                  <div
                    style={{
                      marginTop: "10px",
                      fontWeight: "500",
                      fontStyle: "italic",
                      color: "#0000a0",
                      fontSize: "14px",
                      textAlign: "center",
                      display: "grid",
                      gap: "8px",
                      // gridTemplateColumns: "repeat(auto-fit, minmax(300px, auto))",
                      // justifyContent: "start",
                    }}
                  >
                    {/* {selectedOptions?.length
                      ? selectedOptions.map((o) => o.value)
                      : "No Audit Criteria Selected"} */}

                    {selectedOptions?.length ? (
                      selectedOptions.map((o, index) => (
                        <span className="bg-gray-200 rounded grid py-2 text-gray-700" key={index} style={{ marginRight: "8px",alignContent:"center",alignItems:"center" }}>
                          {o.value}
                        </span>
                      ))
                    ) : (
                      <span>No Audit Criteria Selected</span>
                    )}
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Are you sure you want to proceed?
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: "500",
                      fontStyle: "italic",

                    }}
                    className="text-red-500"
                  >
                    <span className="text-red-500">*</span>Note - Mars QMS must be selected.
                  </div>
                </div>
              </DialogContent>
              <DialogActions
                style={{
                  padding: "24px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "40px",
                }}
              >
                <button
                  className="logout-popup-btn primary-btn mars-admin-popup"
                  d
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    submitForm("completed");
                    setOpenPopup(false);
                  }}
                >
                  Yes
                </button>
                <button
                  className="logout-popup-btn secondary-btn mars-admin-popup"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenPopup(false);
                  }}
                >
                  No
                </button>
              </DialogActions>
            </Dialog>
          </div>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            onClose={handleClose}
            message={snackbarMessage}
            autoHideDuration={2000}
            className="success-snackbar"
          />
        </>
      )}

      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default FormComponent;
